import { render, staticRenderFns } from "./ShapesChooser.vue?vue&type=template&id=54e86dc0"
import script from "./ShapesChooser.vue?vue&type=script&lang=ts"
export * from "./ShapesChooser.vue?vue&type=script&lang=ts"
import style0 from "./ShapesChooser.vue?vue&type=style&index=0&id=54e86dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports